import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { useListContext } from "react-admin";
import { useLocation } from "react-router-dom";
/** Clears the list's filters when it opens. */
export var ResetFilters = function (_a) {
    var _b = _a.keepLinkedFilter, keepLinkedFilter = _b === void 0 ? false : _b;
    var setFilters = useListContext().setFilters;
    var location = useLocation();
    useEffect(function () {
        var linked = new URLSearchParams(location.search).has("filter");
        if (setFilters && !(keepLinkedFilter && linked)) {
            setFilters({}, {});
        }
    }, []);
    return _jsx(_Fragment, {});
};
